import { appInitializer } from "auth_app_vue";
import App                from "./landing.vue";
import routes             from "./routes";

appInitializer('vue-app', App, routes);
